var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 42C10 26.916 10 19.372 14.688 14.688C19.376 10.004 26.916 10 42 10C57.084 10 64.628 10 69.312 14.688C73.996 19.376 74 26.916 74 42C74 57.084 74 64.628 69.312 69.312C64.624 73.996 57.084 74 42 74C26.916 74 19.372 74 14.688 69.312C10.004 64.624 10 57.084 10 42Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 54L31.368 31.896C31.553 31.3444 31.9065 30.8648 32.3788 30.525C32.8511 30.1853 33.4182 30.0025 34 30.0025C34.5818 30.0025 35.1489 30.1853 35.6212 30.525C36.0935 30.8648 36.447 31.3444 36.632 31.896L44 54M28 46H40M56 30V54M26 2V10M58 2V10M42 2V10M26 74V82M42 74V82M58 74V82M82 58H74M10 26H2M10 58H2M10 42H2M82 26H74M82 42H74",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIa);
export default __webpack_public_path__ + "static/media/icon_ia.e10fcdc2d6a85ea83651e860fcdc1b00.svg";
export { ForwardRef as ReactComponent };